import { usePageRefresh } from '../../../../context/PageRefreshContext';
import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMonthlyExpenditureReport } from '../../../../redux/actions/SocietyPortal/AccountReportsAction/AccountReportsAction';
import { selectedSocietyStorer } from '../../../../utils/webStorer';
import ReportShell, { ReportActionButtons } from '../components/ReportShell';
import { FinancialYearField, DateField, GetReportButton } from '../components/ReportFilters';
import { getCurrentFY, fyDateRange } from '../components/helpers';
import MonthlyIncomeTable from '../MonthlyIncome/MonthlyIncomeTable';

const MonthlyExpenditure = () => {
    const dispatch = useDispatch();
    const societyId = selectedSocietyStorer.getSocietyId();
    const { meData, meLoading } = useSelector(state => state.AccountReportsReducer || {});

    const [financialYear, setFinancialYear] = useState(getCurrentFY());
    const [asAtDate, setAsAtDate] = useState(fyDateRange(getCurrentFY()).to);

    useEffect(() => {
        setAsAtDate(fyDateRange(financialYear).to);
    }, [financialYear]);

    const handleGet = () => {
        if (!societyId) return;
        dispatch(getMonthlyExpenditureReport({ societyId, financialYear, asAtDate }));
    };
    usePageRefresh(handleGet);

    useEffect(() => { handleGet(); /* eslint-disable-next-line */ }, [societyId]);

    return (
        <ReportShell
            title="Monthly Expenditure"
            actions={<ReportActionButtons
                onExcel={() => window.print()}
                onPrint={() => window.print()}
            />}
            filters={(
                <div className="tw-grid tw-grid-cols-1 sm:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-3 tw-items-end">
                    <FinancialYearField value={financialYear} onChange={setFinancialYear} />
                    <DateField label="As at Date" value={asAtDate} onChange={setAsAtDate} />
                    <div></div>
                    <GetReportButton onClick={handleGet} loading={meLoading} />
                </div>
            )}
        >
            {meLoading && !meData ? (
                <div className="tw-flex tw-items-center tw-justify-center tw-py-16">
                    <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
                        <div className="tw-animate-spin tw-rounded-full tw-h-6 tw-w-6 tw-border-2 tw-border-gray-200 tw-border-t-rose-500"></div>
                        <span className="tw-text-xs tw-text-gray-400">Loading monthly expenditure...</span>
                    </div>
                </div>
            ) : (
                <MonthlyIncomeTable
                    rows={meData?.accounts || meData?.rows || []}
                    totals={meData?.totals}
                />
            )}
        </ReportShell>
    );
};

export default MonthlyExpenditure;
